import Lesson from "./Lesson"
import StatusCard from "./StatusCard"

var Course = (props) => {
    let statuses=["opened","wait","done","locked","homework"]
    //let rand=Math.floor(Math.random()*5)
    //let status=statuses[rand]
    return (
            <div> 

                <StatusCard {...props} >
                    {props.full&&props.lessonsAvailable&&props.lessonsAvailable.map(
                            (lesson,idx)=>(<a key={idx} href={"?course="+props.slug+"&lesson="+lesson.index}><Lesson {...lesson}/></a>)
                        )}
                    {props.full&&props.status=='locked'&&(<div>Доступ к курсу закрыт. Обратитесь <a href={"https://vk.me/public184222109?ref=buyAccess&ref_source="+props.uri}><b>по этой ссылке</b></a> чтобы приобрести доступ</div>)} 
                </StatusCard>
                
            </div>
        
    )
  
}
export default Course;